<ng-container *ngIf="!isLoading; else loadingTemplate">
    <router-outlet></router-outlet>
</ng-container>

<ng-template #loadingTemplate>
    <div class="screen-center">
        <mat-spinner></mat-spinner>
    </div>
</ng-template>